import type { AnalyticsProps, AnalyticsClientOptions } from './analytics.types';

export abstract class AnalyticsClient {
  public abstract reset(): void;
  public abstract track(
    name: string,
    props?: AnalyticsProps,
    options?: AnalyticsClientOptions,
  ): void;
  public abstract alias(id: number, options?: AnalyticsClientOptions): void;
  public abstract identify(
    userId?: number,
    traits?: Record<string, string | number | boolean>,
    options?: AnalyticsClientOptions,
  ): void;
  public abstract page(
    category: string,
    name: string,
    properties?: any,
    options?: AnalyticsClientOptions,
  ): void;
}
